import React from 'react';
import { QRCodeSVG } from 'qrcode.react';

export const CONTATTI = [
  { etichetta: 'Ambrogio', numero: '338 451 4947' },
  { etichetta: 'Casella Noleggio Bus', numero: '345 810 3221' },
  { etichetta: 'Ufficio', numero: '0823 741 491' },
];

const formatta = (d) => (d ? new Date(d).toLocaleDateString('it-IT') : '—');

/**
 * Tesserino di un abbonamento. Il formato (tessera, medio, grande) è scelto
 * in anteprima: il layout è lo stesso, cambia solo la scala.
 *
 * Il QR contiene il codice dell'abbonamento, non un token a scadenza:
 * un tesserino stampato deve restare valido tutto l'anno. Stato, morosità
 * e periodo di validità li verifica il server alla scansione.
 */
const TesserinoAbbonamento = ({ abbonamento, formato = 'grande' }) => {
  const abb = abbonamento;
  const periodo = abb.anno_scolastico_display
    ? `Anno scolastico ${abb.anno_scolastico_display}`
    : `${formatta(abb.data_inizio)} – ${formatta(abb.data_fine)}`;

  return (
    <div className={`tesserino tesserino--${formato}`}>
      <div className="tesserino-intestazione">
        <img src="/logo.png" alt="" className="tesserino-logo" />
        <div>
          <p className="tesserino-azienda">CASELLA NOLEGGIO BUS</p>
          <p className="tesserino-tipo">Tessera di trasporto scolastico</p>
        </div>
      </div>

      <div className="tesserino-corpo">
        <div className="tesserino-dati">
          <p className="tesserino-nome">{abb.titolare_nome || abb.beneficiario_nome || '—'}</p>

          <div className="tesserino-riga">
            <span className="tesserino-etichetta">Tratta</span>
            <span className="tesserino-valore">{abb.tratta || abb.linea_nome || '—'}</span>
          </div>
          <div className="tesserino-riga">
            <span className="tesserino-etichetta">Tratta</span>
            <span className="tesserino-valore">{abb.direzione_display || 'Andata e ritorno'}</span>
          </div>
          <div className="tesserino-riga">
            <span className="tesserino-etichetta">Validità</span>
            <span className="tesserino-valore">{periodo}</span>
          </div>
          <div className="tesserino-riga">
            <span className="tesserino-etichetta">Codice</span>
            <span className="tesserino-valore tesserino-codice">{abb.codice}</span>
          </div>
        </div>

        <div className="tesserino-qr">
          <QRCodeSVG value={abb.codice || ''} size={512} level="M" />
        </div>
      </div>

      <div className="tesserino-contatti">
        {CONTATTI.map((c) => (
          <span key={c.numero}>
            <strong>{c.etichetta}</strong> {c.numero}
          </span>
        ))}
      </div>
    </div>
  );
};

export default TesserinoAbbonamento;
